import { RuleSet } from "../../rules/ruleSet";
import { KeyMap } from "./keyToOrthoMapping";
import { keyMapToString, stringToKeyMap } from "./persistOrtho";
import { OrthoRulesError, orthoRulesToString, stringToOrthoRules } from "./serializeOrthoRules";

export interface VersionError {
  readonly versionError:
  | 'wrong format'
  | 'unsupported version'
  ;
  readonly context: string;
}
export function isVersionError(check: unknown): check is VersionError {
  const test = check as VersionError;
  return test && (test.versionError !== undefined);
}
export function versionErrorToString(error: VersionError): string {
  let str = error.versionError;
  if (error.context) {
    str += ` - "${error.context}"`;
  }
  return str;
}

const fonimKeysFormat = '#fonim-keys';
const currentFonimKeysVersion = '1.0';
const fonimRulesFormat = '#fonim-rules';
const currentFonimRulesVersion = '1.0';

/** KeyMap -> string with a version */
export function keyMapToVersionString(keys: KeyMap) {
  const version = `${fonimKeysFormat} ${currentFonimKeysVersion}\n`;
  const contents = keyMapToString(keys);
  return version.concat(contents);
}

/** string with a version -> KeyMap */
export function versionStringToFonimKeyMap(str: string): KeyMap | VersionError {
  const firstLine = str.substring(0, str.indexOf('\n'));
  if (!firstLine.startsWith(fonimKeysFormat)) {
    return { versionError: 'wrong format', context: firstLine };
  }
  if (!firstLine.endsWith(currentFonimKeysVersion)) {
    return { versionError: 'unsupported version', context: firstLine };
  }
  const content = str.substring(str.indexOf('\n') + 1);
  return stringToKeyMap(content);
}

/** RuleSet -> string with a version */
export function fonimRulesToVersionString(rules: RuleSet) {
  const version = `${fonimRulesFormat} ${currentFonimRulesVersion}\n`;
  const contents = orthoRulesToString(rules);
  return version.concat(contents);
}

/** string with a version -> RuleSet */
export function versionStringToFonimRules(str: string): RuleSet | VersionError | OrthoRulesError {
  const firstLine = str.substring(0, str.indexOf('\n'));
  if (!firstLine.startsWith(fonimRulesFormat)) {
    return { versionError: 'wrong format', context: firstLine };
  }
  if (!firstLine.endsWith(currentFonimRulesVersion)) {
    return { versionError: 'unsupported version', context: firstLine };
  }
  const content = str.substring(str.indexOf('\n') + 1);
  return stringToOrthoRules(content);
}
